import { SelectProps } from './Select.types';
import Select from 'react-select';
import { InputLabelColor } from '../Input/Input.types';
import '../../../styles/Select.css';
import { forwardRef } from 'react';

export default forwardRef<any, SelectProps>(
  (
    {
      label,
      labelColor = InputLabelColor.Black,
      error,
      required,
      disabled,
      isCompany,
      capitalize,
      key,
      ...props
    }: SelectProps,
    ref
  ) => {
    return (
      <div key={key} className="input">
        {label && (
          <span
            className="input__label font-bold"
            style={{
              color: labelColor === InputLabelColor.White ? 'var(--white)' : 'var(--black)',
            }}>
            {label} {required && <span style={{ color: 'red' }}>*</span>}
          </span>
        )}
        <Select
          ref={ref}
          className="react-select-container"
          classNamePrefix="react-select"
          styles={{
            control: (provided, state) => ({
              ...provided,
              background: '#fff',
              borderWidth: 1,
              borderColor: state.isFocused
                ? isCompany
                  ? 'var(--secondary-50) !important'
                  : 'var(--primary-50) !important'
                : undefined,
              // boxShadow: state.isFocused ? "0px 0px 6px #DE5835" : "none",
              minHeight: '30px',
              height: '34px',
              boxShadow: 'none',
            }),
            option: (provided, state) => ({
              ...provided,
              backgroundColor: state.isSelected ? 'var(--primary-light) !important' : undefined,
            }),
            valueContainer: (provided) => ({
              ...provided,
              height: '34px',
              padding: '0 6px',
              ...(capitalize && {
                textTransform: 'capitalize',
              }),
            }),

            input: (provided) => ({
              ...provided,
              margin: '0px',
            }),
            indicatorSeparator: () => ({
              display: 'none',
            }),
            indicatorsContainer: (provided) => ({
              ...provided,
              height: '34px',
            }),
          }}
          isDisabled={disabled}
          noOptionsMessage={({ inputValue }) => !inputValue ? '' : 'Aucun résultat trouvé'}
          {...props}
        />
        {/* <select value={selectValue} onChange={e => console.log(e)} {...props}>
          {
            options?.map(({ label, value }, optionIndex) => (
              <option key={optionIndex} value={value}>{label}</option>
            ))
          }
        </select> */}
        <span className="input__error">{error}</span>
      </div>
    );
  }
);
